import React from "react";
import "./BenevvButton.css"

interface BenevvButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string
}

function BenevvButton(props: BenevvButtonProps) {
  const {text, ...rest} = props;

  return (
    <div {...rest} className={"benevv-button"}>
      <p className={'benevv-button-text'}> {text} </p>
    </div>
  )
}

export default BenevvButton;
